// src/components/portfolio/add-asset/components/SelectedSymbol.js
import React from 'react';
import CurrencyIcon from '../utils/icons/CurrencyIcon';
import StockIcon from '../utils/icons/StockIcon';

const SelectedSymbol = ({ symbol, searchMode, onClear }) => {
  if (!symbol) return null;

  const getTypeLabel = () => {
    switch (searchMode) {
      case 'fund':
        return 'TEFAS Fonu';
      case 'currency':
        return 'Para Birimi';
      case 'local':
        return 'BIST Hisse';
      case 'api':
        return 'Global Varlık';
      default:
        return '';
    }
  };

  const getIcon = () => {
    switch (searchMode) {
      case 'currency':
        return <CurrencyIcon symbol={symbol.symbol} size="md" />;
      case 'fund':
        return <StockIcon symbol={symbol.symbol} symbolInfo={{ type: 'FUND' }} />;
      default:
        return <StockIcon symbol={symbol.symbol} symbolInfo={symbol} />;
    }
  };

  return (
    <div className="mt-2 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-md">
      <div className="flex items-center space-x-3">
        {getIcon()}
        <div className="flex-1 min-w-0">
          <div className="font-medium text-gray-900 dark:text-gray-100">
            {symbol.symbol}
          </div>
          <div className="text-sm text-gray-600 dark:text-gray-400 truncate">
            {symbol.name}
          </div>
          <div className="text-xs text-gray-500 dark:text-gray-500">
            {searchMode === 'fund' ? (symbol.info?.fundType || getTypeLabel()) : getTypeLabel()}
          </div>
        </div>
      </div>
      <button
        type="button"
        onClick={onClear}
        className="text-xs text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 mt-2"
      >
        Farklı bir sembol seç
      </button>
    </div>
  );
};

export default SelectedSymbol;